import React from 'react';

import DataSources from '../../features/datasources/DataSources';

const DataList: React.FC = () => <DataSources />;

export default DataList;
